module.exports = __webpack_public_path__ + "img/logo_w.6929cdfc.svg";